jQuery(document).ready(function($) {


	//START -> LOAD ANIMATIONS
	//grab all elements that have the .ux-loading-item class
	var uxElements = $('.ux-loading-item');

	$(window).bind("load", function() {
		//grab all elements that have the .ux-loading-item class
		var uxElements = $('.ux-loading-item');

		//run through the uxElements object array
		if (uxElements) { //run through the uxElements object array
			uxElements.each(function(index) {
				//make instances of each one - this
				var Element = $(this);
				//run a time out and add class of active and multiply the delay times the position it is in the object
				setTimeout(function() {
					Element.addClass('active');
				}, 400 * index);
			});
		}
	});
	//END -> LOAD ANIMATIONS
	
	// drop down filters
    setTimeout(function() {
        $(".filterSection__filters select").selectpicker({ dropupAuto: false });
        $("body").live('search_filters_rendered', function() {
            $(".filterSection__filters select").selectpicker('refresh');
        });
        $(".filterSection__filters.filters").fadeIn();
    }, 600);
    // end of dropdown filters

	//START -> HEADER SEARCH TOGGLE
      	$('.search-toggle-button').on('click', function () {
      		$('#search-toggle').toggleClass('active');
      		$('#menuToggle').removeClass('active');
      		$('#search-toggle #searchform #alg-search').focus();
      		$('#alg-search').typeahead('close');
      	});
      	//END -> HEADER SEARCH TOGGLE

      	//START -> HEADER MENU TOGGLE
      	$('#menu-toggle').on('click', function() {
      		$('#menu-toggle').toggleClass('active');
      		$('#menu-top-menu > .menu-item').removeClass('active');
      		if (jQuery(window).width() <= 1024) {
      			$('#whitewrap').toggleClass('open-menu');
      		}
      	});

		$('#menu-toggle').on('click', function() {
			$('#menu-toggle').toggleClass('active');
			$('#menu-top-menu > .menu-item').removeClass('active');
			if (jQuery(window).width() <= 1024) {
				$('#whitewrap, body.stacks-enabled .di-stacks--top').toggleClass('open-menu');
			}
		});

      	if($(window).width() < 1025){
      		$('ul.nav > li > ul > li.menu-item-has-children > a').append('<span class="caret"></span>')
      		$("ul.nav > li > ul > li.menu-item-has-children > a").click(function(e) {
      			if($(this).next('ul').is(":visible") == false) {
      				$(this).next('ul').show();
					$(this).addClass("active-menu");
      			} else {
      				$(this).next('ul').hide();
					$(this).removeClass("active-menu");
      			}
      			return false;
      		});
      	};
      	//END -> HEADER MENU TOGGLE

	// START -> Mobile Footer Menus
	if ($(window).width() <= 768) {
		$('.footerTop--right .widget').on('click', function(){
			$(this).toggleClass('active').siblings().removeClass('active');
			$(this).find(' > div').slideToggle().parent().siblings().find(' > div').slideUp();
		});
	}
	//END -> Mobile Footer Menus

 
  $(".phone.phone-service").html('<a href="/schedule-service/" class="header-info-schedule">Schedule Service</a>');

});
